function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#96D07C",
  d: "M2.527 17.92a.436.436 0 01-.234.08C2.12 18 2 17.844 2 17.575V4a4 4 0 014-4h28a4 4 0 014 4v6a4 4 0 01-4 4H8a4.04 4.04 0 01-.487-.03l-4.986 3.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#73E1E0",
  d: "M7.51 44.97L2.528 47.92a.436.436 0 01-.234.08C2.12 48 2 47.844 2 47.575V35a4 4 0 014-4h20a4 4 0 014 4v6a4 4 0 01-4 4H8a4.04 4.04 0 01-.49-.03z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFD476",
  d: "M46 19.5v13.575c0 .269-.12.425-.293.425a.436.436 0 01-.234-.08l-4.984-3.95c-.16.02-.324.03-.489.03H18a4 4 0 01-4-4v-6a4 4 0 014-4h24a4 4 0 014 4z"
}));

var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgComments;